__webpack_require__.b = self.location + "";

// object to store loaded chunks
// "1" means "already loaded"
var installedChunks = {
	792: 1
};

// no chunk install function needed
// no chunk loading

// no HMR

// no HMR manifest